import { post,get,getJ,put,deleteJ,getExcel,uploadFile,uploadImage,uploadSort,upload,postOther,getPDF,deletes,importExcel,getCode } from '@/utils/axios'
import  baseURL  from '@/utils/axios/axios'
import store from '../store'

export default {
    UserPager(data){
        return get('User/GetUserPager',data)
    },
    UpdateUserState(data){
        return post('User/UpdateUserState',data)
    },
    EditUser(data){
        return post('User/EditUser',data)
    },
    EditDynamic(data){
        return post('AdminDynamic/UpdateDynmic',data)
    },
    AddDynamic(data){
        return post('AdminDynamic/AddDynamic',data)
    },
    DeleteDynamic(data){
        return post('AdminDynamic/DeleteDynamic',data)
    },
    GetDynamic(data){
        return get('AdminDynamic/GetDynamic',data)
    },
    GetDynamicTags(data){
        return get('AdminDynamic/GetDynamicTags',data)
    },
    QueryChatMsg(data){
        return get('Message/QueryChatMsg',data)
    },
    QueryChatSnapMsg(data){
        return get('Message/QueryChatSnapMsg',data)
    },

    GetCareerReal(data){
        return get('AdminRenZheng/GetCareerReal',data)
    },
    GetEducationReal(data){
        return get('AdminRenZheng/GetEducationReal',data)
    },
    GetIdCarReal(data){
        return get('AdminRenZheng/GetIdCarReal',data)
    },
    GetIncomeReal(data){
        return get('AdminRenZheng/GetIncomeReal',data)
    },
    GetRealEstateReal(data){
        return get('AdminRenZheng/GetRealEstateReal',data)
    },
    GetVehicleReal(data){
        return get('AdminRenZheng/GetVehicleReal',data)
    },
    doRenZheng(data){
        return post('AdminRenZheng/doRenZheng',data)
    },
    QueryUserInfoFile(data){
        return get('UserInfoFile/QueryUserInfoFile',data)
    },

    SendMsg(data){
        return post('Message/SendMsg',data)
    },
    QueryFeedback(data){
        return get('Feedback/QueryFeedback',data)
    },
    QueryAppeal(data){
        return get('Appeal/QueryAppeal',data)
    },
    UpdateOperationState(data){
        return post('Appeal/UpdateOperationState',data)
    },
    UpdateUserFileState(data){
        return post('UserInfoFile/UpdateUserFileState',data)
    },
    uploadFile(file,params){
        return uploadFile('',file,params)
    },
    uploadImage(file,params){
        return uploadImage('',file,params)
    },
    sendCode(datas){
        return get('OAuth/SendCode',datas)
    },
    getImageCode(datas){
        return get('OAuth/GetImageCode')
    },

    GetWoManCall(datas){
        return get('Config/GetWoManCall',datas)
    },
    GetManCall(datas){
        return get('Config/GetManCall',datas)
    },
    GetTags(datas){
        return get('Config/GetTags/'+datas)
    },
    GetUserPics(datas){
        return get('UserPic/GetUserPics/'+datas)
    },

    QueryPayInfo(datas){
        return get('PayInfo/QueryPayInfo',datas)
    },

    DeleteUser(datas){
        return post('User/DeleteUser',datas)
    },

    getMiniConfig(datas){
        return get('Config/GetMiniConfig',datas)
    },
    UpMiniConfig(datas){
        return post('Config/UpMiniConfig',datas)
    },
}